module.exports = __webpack_public_path__ + "media/src/assets/images/check-in-568c097ad1482d1230ba063f0e521406.svg";